import React, { useEffect, useState } from 'react';
import TabView from '../../components/TabView';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import FpoEnquiries from './FpoEnquiries';
import OldEnquiries from './OldEnquiries';
import FpoCbbo from './FpoCbbo';
import FpoFpo from './FpoFpo';
import FpoUsers from './FpoUsers';
import { getFpoSummary } from '../../services/enquiries';
import { toast } from 'react-toastify';
import { Users, Building2, UserCheck, ShieldCheck, Briefcase } from 'lucide-react';

const FPOs = () => {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("CBBO");
    const [summary, setSummary] = useState([]);

    const handleTabChange = (value) => {
        setActiveTab(value);
    };


    const fetchSummary = async () => {
        setLoading(true);
        try {
            let res = await getFpoSummary();
            if (res.status === 200) {
                const data = res.data;
                setSummary(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSummary();
    }, []);

    const getMetricConfig = (name) => {
        const lowerName = name?.toLowerCase() || '';
        if (lowerName.includes('cbbo')) return { icon: <Building2 className="w-5 h-5" />, color: 'blue' };
        if (lowerName.includes('fpo')) {
            if (lowerName.includes('active')) return { icon: <UserCheck className="w-5 h-5" />, color: 'emerald' };
            return { icon: <Users className="w-5 h-5" />, color: 'violet' };
        }
        if (lowerName.includes('user')) return { icon: <Briefcase className="w-5 h-5" />, color: 'amber' };
        return { icon: <ShieldCheck className="w-5 h-5" />, color: 'indigo' };
    };

    const colorClasses = {
        blue: { bg: 'bg-blue-50', text: 'text-blue-600', iconBg: 'bg-blue-100', border: 'border-blue-100' },
        emerald: { bg: 'bg-emerald-50', text: 'text-emerald-600', iconBg: 'bg-emerald-100', border: 'border-emerald-100' },
        violet: { bg: 'bg-violet-50', text: 'text-violet-600', iconBg: 'bg-violet-100', border: 'border-violet-100' },
        amber: { bg: 'bg-amber-50', text: 'text-amber-600', iconBg: 'bg-amber-100', border: 'border-amber-100' },
        indigo: { bg: 'bg-indigo-50', text: 'text-indigo-600', iconBg: 'bg-indigo-100', border: 'border-indigo-100' },
    };

    const SummaryCard = ({ item, isLoading }) => {
        if (isLoading) {
            return (
                <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm animate-pulse">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-gray-100 rounded-lg"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-3 bg-gray-100 rounded w-1/2"></div>
                            <div className="h-5 bg-gray-100 rounded w-1/3"></div>
                        </div>
                    </div>
                </div>
            );
        }

        const config = getMetricConfig(item?.name);
        const styles = colorClasses[config.color] || colorClasses.indigo;

        return (
            <div className={`group relative overflow-hidden bg-white ${styles.bg} rounded-xl p-4 border ${styles.border} shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1`}>
                <div className="flex items-center space-x-3">
                    <div className={`p-2 rounded-lg ${styles.iconBg} ${styles.text} transition-transform duration-300 group-hover:scale-110`}>
                        {config.icon}
                    </div>
                    <div className="min-w-0">
                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider truncate">
                            {item?.title || 'Unknown'}
                        </p>
                        <p className={`text-xl font-bold ${styles.text} mt-0.5`}>
                            {item?.value || 0}
                        </p>
                    </div>
                </div>
                <div className="absolute top-0 right-0 p-1 opacity-0 group-hover:opacity-10 transition-opacity">
                    {React.cloneElement(config.icon, { className: 'w-12 h-12 -mr-4 -mt-4' })}
                </div>
            </div>
        );
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Enquiries' },
            { name: "FPOs" },
        ]} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mt-4">
            {loading ? (
                Array(5).fill(0).map((_, i) => <SummaryCard key={i} isLoading={true} />)
            ) : (
                summary.map((item, index) => (
                    <SummaryCard key={index} item={item} />
                ))
            )}
        </div>

        <div className="py-4">
            <StyledHeadingText text={activeTab} />
        </div>
        <TabView
            onChanged={(val) => handleTabChange(val)}
            isCenterAligned={false}
            tabs={[
                {
                    key: 'CBBO',
                    title: 'CBBO',
                    content: (<FpoCbbo />),
                },
                {
                    key: 'FPO',
                    title: 'FPO',
                    content: (<FpoFpo />),
                },
                {
                    key: 'FPO Enquiry',
                    title: 'FPO Enquiry',
                    content: (<FpoEnquiries />),
                },
                {
                    key: 'FPO Users',
                    title: 'FPO Users',
                    content: (<FpoUsers />),
                },
            ]} />
    </>
    );
};
export default FPOs;